import React, { useCallback, useState } from 'react';
import { Field } from '@atlaskit/form';
import Select from '@atlaskit/select';
import { useIntl } from '@atlassian/jira-intl';
import { useRouterActions } from '@atlassian/react-resource-router';
import type { ProjectCategory } from '../../../model/types';
import messages from './messages';
import Option from './option/view.tsx';

export type Props = {
	isAdmin: boolean;
	label: string;
	placeholder: string;
	selectedValue: ProjectCategory | undefined;
	isInitiallyOpen?: boolean;
	allProjectCategories: ProjectCategory[];
	isSimplified?: boolean;
	onChange: (
		category:
			| {
					value: string;
					label: string;
			  }
			| undefined,
	) => void;
};

export const ProjectCategoryView = (props: Props) => {
	const {
		label,
		placeholder,
		allProjectCategories,
		onChange,
		selectedValue,
		isAdmin,
		isInitiallyOpen,
		isSimplified,
	} = props;
	const [isOpen, setIsOpen] = useState(isInitiallyOpen);
	const closeMenu = () => setIsOpen(false);
	const openMenu = () => setIsOpen(true);
	const { formatMessage } = useIntl();
	const { push } = useRouterActions();

	const myOnChange = useCallback(
		// @ts-expect-error - TS7006 - Parameter 'newOption' implicitly has an 'any' type.
		(newOption) => {
			if (newOption != null && newOption.link != null) {
				push(newOption.link);
			} else {
				onChange(newOption);
			}
		},
		[onChange, push],
	);

	const options = allProjectCategories.map((option) => ({
		label: option.name,
		value: option.id,
	}));

	const optionsWithAdminLink = [
		...options,
		{
			label: formatMessage(messages.manageCategoryLabel),
			value: 'manage',
			link: '/secure/admin/projectcategories/ViewProjectCategories!default.jspa',
		},
	];
	const selectedCategory = selectedValue
		? { value: selectedValue.id, label: selectedValue.name }
		: undefined;

	return (
		<Field name="project-category" label={label}>
			{({ fieldProps }) => (
				<Select
					inputId={fieldProps.id}
					isClearable
					placeholder={placeholder}
					options={isAdmin ? optionsWithAdminLink : options}
					onChange={myOnChange}
					value={selectedCategory}
					shouldFitContainer
					onMenuOpen={openMenu}
					onMenuClose={closeMenu}
					menuIsOpen={isOpen}
					components={{
						// @ts-expect-error - TS2322 - Type '(props: Props) => JSX.Element' is not assignable to type 'ComponentType<OptionProps<OptionTypeBase, boolean, GroupTypeBase<OptionTypeBase>>> | undefined'.
						Option,
					}}
					isDisabled={!!(!isSimplified && !isAdmin)}
				/>
			)}
		</Field>
	);
};
